module.exports = __webpack_public_path__ + "static/media/vacuum-robot.f66f78aa.svg";